import  moment from 'moment';
import { Api } from '../services/api.service';

export abstract class BaseService {

  constructor(protected api: Api, public apiUrl: string) {

  }

  // get detail data
  public get(params?: any) {
    return this.api.get(`${this.apiUrl}/${params}`);
  }

  public create(model: Object, isUserGlobalErrorHandler: boolean = true) {
    return this.api.post(`${this.apiUrl}`, model, {}, isUserGlobalErrorHandler);
  }

  public update(id: string, model: Object, isUserGlobalErrorHandler: boolean = true) {
    return this.api.put(`${this.apiUrl}/${id}`, model, isUserGlobalErrorHandler);
  }

  public detele(id: number, selectedDate: moment.Moment = null) {
    if (selectedDate) {
      const params: any = {
        selectedDate: moment(selectedDate).format('L'),
      };
      return this.api.delete(`${this.apiUrl}/${id}`, params);
    }

    return this.api.delete(`${this.apiUrl}/${id}`, {});
  }

  // Get others data such as dropdown
  public getData(sourceUrl, params?: any) {
    return this.api.get<Object>(sourceUrl, params);
  }

  // Get list data
  public getList(params?: any) {
    return this.api.get(`${this.apiUrl}/get-list`, params);
  }
}
